// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Improbability Universe - Aliens Configuration
 * 
 * IMPORTANT: This file only contains the planet-to-alien mapping.
 * All alien definitions are in src/config/AlienSpeciesConfig.js
 * 
 * Workflow:
 * 1. Add alien to AlienSpeciesConfig.js first
 * 2. Then map it to planets here
 */

export const ImprobabilityAliensPlanets = {
  // Planet-specific alien populations
  planets: {
    // MAGRATHEA (300) - Planet builders
    300: ['magratheans', 'mice', 'babelfish'],
    
    // BETELGEUSE SEVEN (301) - Vogon bureaucracy center
    301: ['vogons', 'babelfish'],
    
    // FROGSTAR WORLD B (302) - Existential dread
    302: ['hooloovoo', 'greys', 'energybeings'],
    
    // MILLIWAYS (303) - Restaurant at the End of the Universe
    303: ['ferengi', 'babelfish', 'aquatic', 'crystalline'],
    
    // DAMOGRAN (304) - Fjords and swamps
    304: ['mice', 'aquatic', 'gaseous'],
    
    // KAKRAFOON (305) - Telepathic planet
    305: ['hooloovoo', 'photonic', 'energybeings'],
    
    // URSA MINOR BETA (306) - Publishing headquarters
    306: ['babelfish', 'mice', 'greys'],
    
    // SQORNSHELLOUS ZETA (307) - Mattress world
    307: ['gaseous', 'aquatic'],
    
    // PRELIUMTARN (308) - Infinite Improbability Drive
    308: ['hooloovoo', 'photonic', 'energybeings', 'crystalline'],
    
    // BARTLEDAN (309) - Shoe shops everywhere
    309: ['ferengi', 'hivemind', 'babelfish'],
    
    // VILTVODLE VI (310) - Ravenous Bugblatter Beast homeworld
    310: ['greys', 'gaseous', 'crystalline'],
    
    // ARKINTOOFLE MINOR (311) - Perfectly normal planet
    311: ['mice', 'aquatic', 'photonic'],
    
    // LAMUELLA (312) - Sandwich maker's paradise
    312: ['babelfish', 'hooloovoo', 'energybeings']
  },
  
  // Random encounter aliens (can appear during exploration/events)
  randomEncounters: [
    'vogons',
    'babelfish',
    'mice',
    'hooloovoo',
    'greys',
    'crystalline',
    'gaseous'
  ],
  
  // Hostile aliens that might attack
  hostileSpecies: [
    'vogons'
  ],
  
  // Friendly aliens for trading
  friendlyTraders: [
    'magratheans',
    'ferengi',
    'babelfish',
    'crystalline',
    'aquatic'
  ]
};

export default ImprobabilityAliensPlanets;
